<template>
  <div class="">
    <div v-show="!isdetail">
      <!-- <el-input placeholder="可輸入交易編號進行檢索" clearable v-model="condition" @input="getdata"></el-input> -->
      <search :form="form" @submit="getdata"></search>
      <div class="mb15"></div>
      <el-table :data="deallist" border :header-cell-style="{background:'#FAFAFA'}" ref="multipleTable" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="50">
        </el-table-column>
        <el-table-column width="120" property="businessnum" label="交易編號">
          <template slot-scope="scope">
            <div class="phonecel">交易編號</div>
            <span :class="{'unlink':scope.row.status==5}">
              B{{scope.row.businessnum}}
            </span>
          </template>
        </el-table-column>
        <el-table-column width="150" property="addtime" label="時間">
          <template slot-scope="scope">
            <div class="phonecel">時間</div>
            <span :class="{'unlink':scope.row.status==5}">{{scope.row.addtime}}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column width="300" property="account" label="交易賬戶">
          <template slot-scope="scope">
            <div class="phonecel">交易賬戶</div>
            <div :class="{'unlink':scope.row.status==5}" v-if="scope.row.mode==0">{{scope.row.store_name}} {{scope.row.currency_short_name}} {{scope.row.currency_name}} </div>
            <div :class="{'unlink':scope.row.status==5}" v-if="scope.row.mode==1">
              <div v-if="scope.row.bank_account.id">
                <div>{{scope.row.bank_account.account_name}} {{addSpace(scope.row.bank_account.account_num)}} </div>
                <div>{{scope.row.bank_account.bankname}} </div>
                <div>{{scope.row.currency_short_name}} {{scope.row.currency_name}} </div>
              </div>
              <div v-else>
                未關聯賬戶
              </div>
            </div>
          </template>
        </el-table-column> -->
        <el-table-column label="入款貨幣">
          <template slot-scope="scope">
            <div class="phonecel">入款貨幣</div>
            <span :class="{'unlink':scope.row.status==5}">
              {{scope.row.currency_short_name}}
              {{tomoney(scope.row.money)}}
            </span>
          </template>
        </el-table-column>
        <el-table-column property="status" label="狀態">
          <template slot-scope="scope">
            <div class="phonecel">狀態</div>
            <statustext :status="scope.row.status"></statustext>
          </template>
        </el-table-column>
        <el-table-column property="file" label="水單">
          <template slot-scope="scope">
            <div class="phonecel">水單</div>
            <div v-if="scope.row.files.length>0" class="flex">
              <img :src="apiurl+scope.row.files[0].fileurl" height="35px" class="mr10" @click="showimg_url=apiurl+scope.row.files[0].fileurl;showimg_dialog = true;">
              <el-link v-if="scope.row.files.length>1" @click="Details(scope.row.id)">還有{{scope.row.files.length-1}}張</el-link>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="mark" label="備註" align="center">
          <template slot-scope="scope">
            <div class="phonecel">備註</div>
            <div>{{scope.row.mark}}</div>
          </template>
        </el-table-column>
        <el-table-column label="開單員" width="120">
          <template slot-scope="scope">
            <div class="phonecel">開單員</div>
            <span :class="{'unlink':scope.row.status==5}">
              {{scope.row.username}}
              ({{scope.row.operator}})
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="status" width="90px;" label="操作" align="center">
          <template slot-scope="scope">
            <div class="phonecel">操作</div>
            <el-link @click="Details(scope.row.id)"><i class="el-icon-circle-plus-outline"></i>詳細</el-link>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 20px">
        <el-button @click="getResult()">選好了</el-button>
        <el-button @click="toggleSelection()">取消選擇</el-button>
      </div>
      <div class="page-bottom" style="margin-top:15px;">
        <div>
          Total: {{pager.p_count}}條記錄
        </div>
        <div></div>
        <div>
          <el-pagination background @size-change="changesize" @current-change="changepage" :current-page="pager.p_now" :page-sizes="[5, 10, 20, 50]" :page-size="parseInt(pager.p_size)" layout="sizes, prev, pager, next, jumper" :total="pager.p_count">
          </el-pagination>
        </div>
      </div>
      <!-- 水單查看 -->
      <el-dialog :visible.sync="showimg_dialog" height="80%" center :append-to-body="true">
        <img :src="showimg_url" alt="" style="width:100%;margin:0 auto;">
      </el-dialog>
    </div>

    <div v-if="isdetail">
      <buybuinessdetails :visible.sync="isdetail" @refresh="getdata" :id="id"></buybuinessdetails>
    </div>
  </div>
</template>

<script>
import statustext from "@/components/StatusText.vue";
import search from "./SearchBusiness.vue";
import buybuinessdetails from "@/components/BuyBusinessDetails.vue"
export default {
  components: {
    statustext,
    search,
    buybuinessdetails
  },
  name: "buybusienesAssoclate",
  props: ['order_id', 'is_linker'],
  data () {
    return {
      isdetail: false,
      id: 0,
      condition: '',
      multipleSelection: [],
      deallist: [],
      showimg_url: '',
      showimg_dialog: false,
      page: 1,
      pagesize: 5,
      pager: [],
      form: {
        mode: '-1',
        currency_id: '-1',
        status: '-1',
        staff_id: '-1',
        startmoney: '',
        endmoney: '',
        starttime: '',
        endtime: '',
        businessnum: '',
        ordernum: '',
        mark: '',
        sortname: 'addtime',
        orderby: 'DESC',
      },
    }
  },
  methods: {
    checkchoose () {
      if (this.multipleSelection.length == 0) {
        this.$notify({
          message: '請選擇需要關聯的交易單',
          type: 'warning',
          duration: 4000,
          offset: 160
        });
        return false;
      }

      if (this.is_linker == 0) {
        let currency_id = 0;
        let currency_pass = true;
        this.multipleSelection.some(item => {
          if (currency_id == 0) {
            currency_id = item.currency_id;
          } else if (currency_id != item.currency_id) {
            currency_pass = false;
            return true;
          }
        })
        // 選擇交易單狀態檢查
        if (!currency_pass) {
          this.$notify({
            message: '只允許選擇同種貨幣交易單進行關聯',
            type: 'warning',
            duration: 6000,
            offset: 160
          });
          return false;
        }
      }
      return true;
    },
    Details (id) {
      this.id = id;
      this.isdetail = true;
    },
    changepage (val) {
      this.page = val;
      this.getdata();
    },
    changesize (val) {
      this.pagesize = val;
      this.getdata();
    },
    getdata () {
      this.post('/api/business/buy_assoclate', {
        type: -1,
        buytype: 0,
        page: this.page,
        pagesize: this.pagesize,
        ...this.form,
      }).then((res) => {
        this.deallist = res.info;
        this.pager = res.pager;
        this.page = 1;
      }).catch((err) => {
        console.log(err)
      })
    },
    toggleSelection () {
      this.$refs.multipleTable.clearSelection();
    },
    getResult () {
      let check_res = this.checkchoose();
      if (check_res) {
        let ids = [];
        this.multipleSelection.map(item => {
          ids.push(item.id);
        });
        let order_id = this.order_id;
        let is_linker = this.is_linker;
        let buytype = 0;
        let mso_id = this.sessionRead('mso_id');
        let staff_id = this.sessionRead('staff_id');
        if (order_id == 0) {
          this.$emit('update:visible', false);
          this.$emit('getids', ids);
        } else {
          this.post('/api/order/association', { ids, order_id, mso_id, staff_id, buytype, is_linker })
            .then(response => {
              if (response == 'success') {
                this.$emit('reload');
                this.$notify({
                  showClose: true,
                  message: '選擇成功',
                  type: 'success',
                  duration: 6000,
                  offset: 160
                })
                this.$emit('update:visible', false);
              } else {
                this.$notify({
                  message: response,
                  type: 'error',
                  duration: 6000,
                  offset: 160
                });
              }
            }).catch(error => {
              console.log(error);
            })
        }


      }

    },
    handleSelectionChange (val) {
      this.multipleSelection = val;
    },
    init () {
      this.multipleSelection = this.selection;
    }
  },
  created () {
    this.getdata();
  },
  watch: {
    'form': { // 動態監控利率變化
      handler: function (val) {
        this.getdata();
      },
      deep: true
    },
  }
}
</script>

<style scoped>
.mb15 {
  margin-bottom: 15px;
}
</style>
